import { render, staticRenderFns } from "./DealItemView.vue?vue&type=template&id=01ec306f&"
import script from "./DealItemView.vue?vue&type=script&lang=ts&"
export * from "./DealItemView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports